import Logout from "./components/logout";
// import "bootstrap/dist/css/bootstrap.min.css";
import { connect } from "react-redux";
import { Route, Switch, Redirect } from "react-router-dom";
import Home from "./components/home";
import "./custom.scss";
import { useEffect, useState } from "react";
import { eng, tr } from "./util/languageData";
import Login from "./components/login";
import ShiftCashPost from "./components/shiftcash/shiftCashPost";
import ShiftCreditCardPost from "./components/shiftcreditcard/shiftcreditcardpost";
import { ShiftReview } from "./components/shiftreview/shiftreview";
import EmployeeCreditCard from "./components/employeeCreditCard/employeeCreditCard";
// import "./App.css";
import Navigation from "./components/navigation";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State } from "./state/index";
import { bindActionCreators } from "redux";
import ProtectedRoute from "./components/protectedRoute";
import Payment from "./components/payment/payment";
import { PaymentSuccess } from "./components/payment/paymentSuccess";
import { CustomPayment } from "./components/payment/customPayment";
import { Subscription } from "./components/subscription";
import authService from "./services/authService";
import AdminShift from "./components/admin/shift";
import AdminEmployeeDeficit from "./components/deficit/employeeDeficit";
import AdminDeposit from "./components/admin/deposit/deposit";
import AdminCreditCard from "./components/admin/creditcard/creditCard";
import CompanyUserManagement from "./components/admin/company/CompanyUserManagement";
import ContactForm from "./components/contact/ContactForm";
import UserRegistration from './components/auth/UserRegistration';
import AboutPage from "./components/about";
import GlobalAlert from './components/GlobalAlert';
import ShiftReport from './components/report/ShiftReport';
import EmployeeDeficit from "./components/deficit/employeeDeficit";

function App(props: any) {
  // const [appLanguage, setAppLanguage] = useState("en");
  // const { dispatch } = props ?? {};

  // useEffect(() => {
  //   let languageData;
  //   if (
  //     appLanguage === "en" ||
  //     appLanguage === "en-GB" ||
  //     appLanguage === "en-US"
  //   ) {
  //     languageData = eng;
  //   }
  //   if (appLanguage === "tr" || appLanguage === "tr-TR") {
  //     languageData = tr;
  //   }
  //   dispatch(actionSetAppLanguage(appLanguage, languageData));
  // }, [appLanguage, props.language?.appLanguage]);

  // Redux
  const [roles, setRoles] = useState<any>();
  const dispatch = useDispatch();
  const { login, logout, register, updateUserRoles } = bindActionCreators(
    actionCreators.authActions,
    dispatch
  );

  const { setAppLanguage } = bindActionCreators(
    actionCreators.languageActions,
    dispatch
  );

  const state = useSelector((state: State) => state);
  const { isLoggedIn, user } = state.authReducer;

  useEffect(() => {
    if (user && user.roles) {
      setRoles(user.roles);
    }
  }, [user]);

  useEffect(() => {
    console.log("Running environment: " + process.env.NODE_ENV);
    const str = localStorage.getItem("user");
    const user: any = str ? JSON.parse(str) : null;
    if (user) {
      const currentTime = new Date();
      const time = new Date(user?.expirationDate);
      if (user && time <= currentTime) {
        dispatch(logout());
      }
    }
    const pref = localStorage.getItem("language");
    if (pref) {
      if (pref === "en" || pref === "en-GB" || pref === "en-US") {
        dispatch(setAppLanguage("en", eng));
      } else if (pref === "tr" || pref === "tr-TR") {
        dispatch(setAppLanguage("tr", tr));
      } else {
        dispatch(setAppLanguage("en", eng));
      }
    } else {
      const browserLanguage = getBrowserLanguage();
      switch (browserLanguage) {
        case "tr-TR":
          dispatch(setAppLanguage("tr", tr));
          break;
        case "tr":
          dispatch(setAppLanguage("tr", tr));
          break;
        case "en":
          dispatch(setAppLanguage("en", eng));
          break;
        case "en-GB":
          dispatch(setAppLanguage("en", eng));
          break;
        case "en-US":
          dispatch(setAppLanguage("en", eng));
          break;
        default:
          dispatch(setAppLanguage("en", eng));
      }
    }
    getAndUpdateUserRoles();
  }, []);

  const getAndUpdateUserRoles = async () => {
    try {
      const response = await authService.getUserRoles();
      dispatch(updateUserRoles(response.data));
    } catch (e: any) {
      console.dir(e);
    }
  };

  const getBrowserLanguage = () => {
    console.log(window.navigator);
    console.log(window.navigator.language);
    console.log(window.navigator.languages);
    if (window.navigator.languages) {
      return window.navigator.languages[0];
    } else {
      return window.navigator.language;
    }
  };

  return (
    <div>
      <GlobalAlert />
      <div className="navigator">
        <Navigation />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/login" component={Login} />
          <Route path="/logout" component={Logout} />

          {roles?.length > 0 && (
            <Route
              path="/iyzicocustompayment"
              render={() =>
                roles?.includes("ROLE_PAYMENT") ? (
                  <CustomPayment {...props} />
                ) : (
                  <Redirect to="/" />
                )
              }
            />
          )}

          {roles?.length > 0 && (
            <Route
              path="/admin/shift"
              render={() =>
                roles?.includes("ROLE_ADMIN") ? (
                  <AdminShift {...props} />
                ) : (
                  <Redirect to="/" />
                )
              }
            />
          )}

          {roles?.length > 0 && (
            <Route
              path="/admin/creditcard"
              render={() =>
                roles?.includes("ROLE_ADMIN") ? (
                  <AdminCreditCard {...props} />
                ) : (
                  <Redirect to="/" />
                )
              }
            />
          )}
          {roles?.length > 0 && (
            <Route
              path="/admin/deposit"
              render={() =>
                roles?.includes("ROLE_ADMIN") ? (
                  <AdminDeposit {...props} />
                ) : (
                  <Redirect to="/" />
                )
              }
            />
          )}

          {roles?.length > 0 && (
            <Route
              path="/admin/employeedeficit"
              render={() =>
                roles?.includes("ROLE_ADMIN") ? (
                  <AdminEmployeeDeficit {...props} />
                ) : (
                  <Redirect to="/" />
                )
              }
            />
          )}

          {/* {roles?.length > 0 && (
            <Route
              strict
              path="/iyzicopayment/success"
              render={() =>
                roles?.includes("ROLE_PAYMENT") ? (
                  <PaymentSuccess {...props} />
                ) : (
                  <Redirect to="/" />
                )
              }
            />
          )} */}
          <Route
            strict
            path="/iyzicopayment/success"
            component={PaymentSuccess}
          />

          {roles?.length > 0 && (
            <Route
              exact
              path="/iyzicopayment"
              render={() =>
                roles?.includes("ROLE_PAYMENT") ? (
                  <Payment {...props} />
                ) : (
                  <Redirect to="/" />
                )
              }
            />
          )}

          {/* {roles?.length > 0 && (
            <Route
              path="/subscription"
              render={() =>
                roles?.includes("ROLE_PAYMENT") ? (
                  <Subscription {...props} />
                ) : (
                  <Redirect to="/" />
                )
              }
            />
          )} */}
          <Route path="/subscription" component={Subscription} />

          {/* New ShiftReport route for all logged-in users */}
          {roles?.length > 0 && (
            <Route
              path="/report/shift"
              render={() => isLoggedIn ? <ShiftReport /> : <Redirect to="/" />}
            />
          )}

          {roles?.length > 0 && (
            <Route
              path="/shiftreview"
              render={() =>
                roles?.includes("ROLE_ADMIN") ||
                roles?.includes("ROLE_USER") ||
                roles?.includes("ROLE_CREDITCARD") ? (
                  <ShiftReview {...props} />
                ) : (
                  <Redirect to="/" />
                )
              }
            />
          )}

          {roles?.length > 0 && (
            <Route
              path="/employeecreditcard"
              render={() =>
                roles?.includes("ROLE_ADMIN") ||
                roles?.includes("ROLE_USER") ||
                roles?.includes("ROLE_CREDITCARD") ? (
                  <EmployeeCreditCard {...props} />
                ) : (
                  <Redirect to="/" />
                )
              }
            />
          )}
          {/* {roles?.includes("ROLE_ADMIN") ||
          roles?.includes("ROLE_USER") ||
          roles?.includes("ROLE_CASH") ? (
            <Route path="/cash" component={ShiftCashPost} />
          ) : null} */}
          {roles?.length > 0 && (
            <Route
              path="/cash"
              render={() =>
                roles?.includes("ROLE_ADMIN") ||
                roles?.includes("ROLE_USER") ||
                roles?.includes("ROLE_CASH") ? (
                  <ShiftCashPost {...props} />
                ) : (
                  <Redirect to="/" />
                )
              }
            />
          )}

          {roles?.length > 0 && (
            <Route
              path="/creditcard"
              render={() =>
                roles?.includes("ROLE_ADMIN") ||
                roles?.includes("ROLE_USER") ||
                roles?.includes("ROLE_CREDITCARD") ? (
                  <ShiftCreditCardPost {...props} />
                ) : (
                  <Redirect to="/" />
                )
              }
            />
          )}

          {roles?.length > 0 && (
            <Route
              exact
              path="/admin/company/users"
              render={() =>
                roles?.includes("ROLE_ADMIN") ? (
                  <CompanyUserManagement />
                ) : (
                  <Redirect to="/" />
                )
              }
            />
          )}
          <Route path="/contact" component={ContactForm} />
          <Route path="/users/register" component={UserRegistration} />
          <Route path="/about" component={AboutPage} />
          <Route path="/employeedeficit" component={EmployeeDeficit} />
        </Switch>
      </div>
    </div>
  );
}

function mapStateToProps(state: any) {
  const { user } = state.auth ?? {};
  const { ...language } = state.languageReducer ?? {};
  return {
    user,
    language,
  };
}

export default connect(mapStateToProps)(App);
